import React from 'react';
import './alias-table.css';

const AliasTable = (props) => {
  const {
    tableHeading,
    aliasEmailList,
    customClass = '',
  } = props;

  const emailListContent = aliasEmailList.map(email => (
    <div className={`col-12 ${customClass}`} key={email}>
      <div className="email-item">{email}</div>
    </div>
  ));

  return (
    <div className="alias-table-section">
      <div className="row">
        <div className={`col-12 ${customClass}`}>
          <h2>{tableHeading}</h2>
        </div>
      </div>
      <div className="row">
        {emailListContent}
      </div>
    </div>
  );
};

export default AliasTable;

